// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aPxi","content":"styles_content__2m6J2","tableWrap":"styles_tableWrap__2SXEF"};